import { ApiContext } from '../../types'
import { AuthHelper } from '@/api_client'
import { deserializeAudio } from '../serializers/audio'

export default async function removeAudios(
  { client, config }: ApiContext,
  ids: number[],
  isPermanent = false,
) {
  const response = await client.audios.remove(AuthHelper.getAccessToken(), {
    ids: ids.join(','),
    is_permanent: isPermanent ? '1' : '0',
  })
  if (response.isSuccess()) {
    const success = response.success()
    return true
  } else {
    console.log('getUsers: fail')
    throw response.fail()
  }
}
